module.exports = __webpack_public_path__ + "static/media/Linkedinwithround.76fb7276.svg";